export default {
  setOtherTab(state, payload) {
    state.otherTabs = { ...state.otherTabs, [payload.tabId]: payload.seenAt };
  },
  removeOtherTab(state, tabId) {
    const otherTabs = { ...state.otherTabs };

    delete otherTabs[tabId];

    state.otherTabs = otherTabs;
  },
  removeStaleOtherTabs(state, seenBefore) {
    const otherTabs = {};

    for (const [tabId, seenAt] of Object.entries(state.otherTabs)) {
      if (seenAt >= seenBefore) otherTabs[tabId] = seenAt;
    }

    state.otherTabs = otherTabs;
  },
  clearOtherTabs(state) {
    state.otherTabs = {};
  },
  setWarningDismissed(state, payload) {
    state.warningDismissed = payload;
  }
};
